import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Container from 'reactstrap/lib/Container';
import { topRatedHelpers } from 'site-modules/shared/utils/top-rated/top-rated-helpers';

export function OtherYears({ year = null, otherYearLinks }) {
  return (
    <Container tag="section" className="other-years text-center pb-1 pb-md-0 mt-3_5">
      <header className="mb-2">
        <span
          className={classnames(
            `size-30 fw-bold highlights-heading`,
            topRatedHelpers.swapTextColor('text-white', year)
          )}
        >
          See Other Years
        </span>
      </header>
      <article>
        {otherYearLinks.map(link => (
          <a className="d-inline-block px-1 py-0_5 size-14 mb-1 mb-md-0" href={link.href} key={link.title}>
            {link.title}
          </a>
        ))}
      </article>
    </Container>
  );
}

OtherYears.propTypes = {
  otherYearLinks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  year: PropTypes.string,
};
